const mapStateToProps = state => 
     ({
        dataOP: state.dataOP.dataOP,
        currentUser: state.security.currentUser

    });

export default mapStateToProps;
